export * from './a2t-shared';
export * from './a2t-ui.forms';
export * from './a2t-ui.component';
export * from './a2t-ui.routes';
export * from './a2t-ui.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/angular2-token/lib/a2t-ui/index.js
// module id = ../../../../angular2-token/lib/a2t-ui/index.js
// module chunks = 3